import React from 'react'

type DomainUrlFieldProps = {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  error?: string
  autoFocus?: boolean
}

export default function DomainUrlField({
  value,
  onChange,
  placeholder = 'projectname',
  error,
  autoFocus,
}: DomainUrlFieldProps) {
  return (
    <div>
      <div className="rt-TextFieldRoot rt-r-size-3 rt-variant-surface relative">
        <span className="pointer-events-none absolute inset-y-0 left-0 z-10 flex items-center pl-3">
          <span
            className={
              value
                ? 'text-[length:var(--font-size-3)] leading-[var(--line-height-3)] text-[var(--gray-12)]'
                : 'text-[length:var(--font-size-3)] leading-[var(--line-height-3)] text-[var(--gray-a9)]'
            }
          >
            {value || placeholder}
          </span>
          {/* i18next-instrument-ignore */}
          <span className="text-[length:var(--font-size-3)] text-[var(--gray-a9)]">
            .disco.ac
          </span>
        </span>
        <input
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          autoFocus={autoFocus}
          autoCapitalize="off"
          autoComplete="off"
          spellCheck={false}
          className="rt-TextFieldInput text-transparent caret-black"
        />
      </div>
      {error && <p className="text-sm text-red-600 m-0 mt-1">{error}</p>}
    </div>
  )
}
